import { Injectable, Req } from '@nestjs/common';
import { InjectRepository } from '@nestjs/typeorm';
import { Raw, Repository } from 'typeorm';
import { ErrorResponse } from '@gtpl/shared-models/common-models';
import { AllCellsResponseModel, CellDto, CellResponseModel } from '@gtpl/shared-models/masters';
import { CellAdapter } from './dto/cells.adapter';
import { Cell } from './cells.entity';
import { CellDTO } from './dto/cells.dto';
import { CellRequest } from './dto/cells.request';

@Injectable()
export class CellsService {
    constructor(
        @InjectRepository(Cell) private cellRepository: Repository<Cell>,
        private cellAdapter: CellAdapter,
      ) { }
      async getCellWithoutRelations(cellId: number): Promise<Cell> {
        //  console.log(employeeId);
            const response = await this.cellRepository.findOne({
            where: {cellId: Raw(alias => `cell_id = '${cellId}'`)},
            });
            // console.log(response);
            if (response) {
            return response;
            } else {
            return null;
            }
        }

      async createCell(cellDto:CellDTO,isUpdate:boolean=false,@Req() request:Request): Promise<CellResponseModel> {
        try {
        
        if (!isUpdate) {
            const cellEntity = await this.getCellWithoutRelations(cellDto.cellId);
          if (cellEntity) {
            throw new ErrorResponse(11104, 'cell already exists');
          }
        }
        const cellEntity: Cell = this.cellAdapter.convertDtoToEntity(cellDto,isUpdate);
        const savedCellEntity: Cell = await this.cellRepository.save(cellEntity);
        const savedCellDto: CellDTO = this.cellAdapter.convertEntityToDto(savedCellEntity);
       
         if (savedCellEntity) {
          const response = new CellResponseModel(true,isUpdate ? 11100 : 11101,isUpdate? 'Cell Updated Successfully':'Cell Created Successfully',savedCellDto);
          return response;
        } else {
          throw new ErrorResponse(11106,'Cell saved but issue while transforming into DTO');
        }
      }
      catch (error) {
        throw error;
      }
    }

    async getAllCells(): Promise<AllCellsResponseModel> { 
        try {
            const cellDto: CellDto[] = [];
            // retrieves all plants
            const cellEntities: Cell[] = await this.cellRepository.find({
                order: { cellName: "DESC" },
            });
            if (cellEntities.length>0) {
                cellEntities.forEach(cellEntity => {
                const convertedCellDto: CellDto = this.cellAdapter.convertEntityToDto(cellEntity);
                cellDto.push(convertedCellDto);
                });
                const response = new AllCellsResponseModel(true, 11208, "Cells retrieved successfully", cellDto);
                return response;
            } else {
                throw new ErrorResponse(99998, 'No Records Found');
            }
        } catch (err) {
            throw err;
        }
    }

    async activateOrDeactivateCell(cellReq: CellRequest): Promise<CellResponseModel> {
        try {
            const cellExists = await this.getCellById(cellReq.cellId);
            if (cellExists) {
                if (cellReq.versionFlag !== cellExists.versionFlag) {
                    throw new ErrorResponse(10113, 'Someone updated the current cell information.Refresh and try again');
                } else {
                    
                        const cellStatus =  await this.cellRepository.update(
                            { cellId: cellReq.cellId },
                            { isActive: cellReq.isActive,updatedUser: cellReq.updatedUser });
                       
                        if (cellExists.isActive) {
                            if (cellStatus.affected) {
                                const cellResponse: CellResponseModel = new CellResponseModel(true, 10115, 'Cell is de-activated successfully');
                                return cellResponse;
                            } else {
                                throw new ErrorResponse(10111, 'Cell is already deactivated');
                            }
                        } else {
                            if (cellStatus.affected) {
                                const cellResponse: CellResponseModel = new CellResponseModel(true, 10114, 'Cell is activated successfully');
                                return cellResponse;
                            } else {
                                throw new ErrorResponse(10112, 'Cell is already  activated');
                            }
                        }
                    // }
                }
            } else {
                throw new ErrorResponse(99998, 'No Records Found');
            }
        } catch (err) {
            throw err;
        }
    }

    async getCellById(cellId: number): Promise<Cell> {
        //  console.log(employeeId);
            const Response = await this.cellRepository.findOne({
            where: {cellId: cellId},
            });
            // console.log(employeeResponse);
            if (Response) {
            return Response;
            } else {
            return null;
            }
        }

}
